/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { CarStatusFromJSON, CarStatusToJSON, } from './';
export function CarPlateStatusDtoFromJSON(json) {
    return CarPlateStatusDtoFromJSONTyped(json, false);
}
export function CarPlateStatusDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'carId': !exists(json, 'carId') ? undefined : json['carId'],
        'plateNumber': !exists(json, 'plateNumber') ? undefined : json['plateNumber'],
        'status': !exists(json, 'status') ? undefined : CarStatusFromJSON(json['status']),
    };
}
export function CarPlateStatusDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'carId': value.carId,
        'plateNumber': value.plateNumber,
        'status': CarStatusToJSON(value.status),
    };
}
